import { render, staticRenderFns } from "./IconTwitter.vue?vue&type=template&id=b6658840"
import script from "./IconTwitter.vue?vue&type=script&lang=js"
export * from "./IconTwitter.vue?vue&type=script&lang=js"
import style0 from "./IconTwitter.vue?vue&type=style&index=0&id=b6658840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports